import { gql } from '@apollo/client'

export const updateFund = gql`
  mutation UpdateFund($data: UpdateFundInput!) {
    updateFund(data: $data) {
      id
      name
    }
  }
`

export const updateGivingGoal = gql`
  mutation UpdateGivingGoal($data: UpdateGivingGoalInput!) {
    updateGivingGoal(data: $data) {
      id
      fundId
      amount
      createdAt
      updatedAt
    }
  }
`

export const updateMyGenerosityFundLogo = gql`
  mutation updateMyGenerosityFundLogo($data: UpdateGenerosityFundLogoInput!) {
    updateMyGenerosityFundLogo(data: $data) {
      fundId
      logo
    }
  }
`

export const giveToGenerosityFundAsGuest = gql`
  mutation giveToGenerosityFundAsGuest($data: GiveToGenerosityFundAsGuest!) {
    giveToGenerosityFundAsGuest(data: $data)
  }
`

export const startIntentToGiveToGenerosityFund = gql`
  mutation startIntentToGiveToGenerosityFund($data: StartIntentToGiveToGenerosityFund!) {
    startIntentToGiveToGenerosityFund(data: $data)
  }
`

export const giveToGenerosityFundAsUser = gql`
  mutation giveToGenerosityFundAsUser($data: GiveToGenerosityFundAsUser!) {
    giveToGenerosityFundAsUser(data: $data) {
      amount
    }
  }
`

export const saveFundSuccessionInstructions = gql`
  mutation SaveFundSuccessionInstructions($fundId: Int!, $data: SuccessionInstructionInput!) {
    saveFundSuccessionInstructions(fundId: $fundId, data: $data) {
      id
      fundId
      successors {
        id
        firstName
        lastName
        email
        address
        phoneNumber
        relationshipToYou
        dateOfBirth
        allocationPercentage
        alternativeAction
      }
      charities {
        id
        charityName
        registrationNumber
        designation
        allocationPercentage
        timeFrame
        timeFrameMonths
        timeFrameYears
        alternativeAction
      }
      createdAt
      updatedAt
    }
  }
`

export const deleteFundSuccessionInstructions = gql`
  mutation DeleteFundSuccessionInstructions($fundId: Int!) {
    deleteFundSuccessionInstructions(fundId: $fundId)
  }
`

export const createDonorFund = gql`
  mutation CreateDonorFund($input: CreateDonorFundInput!) {
    createDonorFund(input: $input) {
      id
      name
      number
      fundProfile {
        portalName
      }
    }
  }
`
